import { View } from "binder"
import { StopReasonEditorViewModel } from "./stopReasonEditor-viewModel"
import { StopGroupSelectorViewModel } from "../stopGroupSelector-viewModel";

export class StopReasonEditorView extends View<StopReasonEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-7F835659-80F0-4E8E-9629-F82855F8995A"
    }
    loadHtml(): string {
        let element = require('./stopReasonEditor.html').default;
        let style = require('./stopReasonEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set stopGroupId(v: string) { this._stopGroupId = v; } public get stopGroupId(): string { return this._stopGroupId; } private _stopGroupId: string;
    public set stopGroupSelector(v: StopGroupSelectorViewModel) { this._stopGroupSelector = v; } public get stopGroupSelector(): StopGroupSelectorViewModel { return this._stopGroupSelector; } private _stopGroupSelector: StopGroupSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
